var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientId)?_c('div',{class:{ disabled: _vm.googleLoginLoading }},[_c('div',{ref:"googleButtonContainer"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }